namespace GeniuzPOS.ReportMasterData {
    export interface Report1332ShopPaymentTypeRefTypeRow {
        Id?: string;
        ShopId?: string;
        ShopName?: string;
        DocDate?: string;
        PaymentType?: number;
        PaymentName?: string;
        RefType?: string;
        RefName?: string;
        ExchangeRate?: number;
        ReceiptInAmt?: number;
        ReceiptOutAmt?: number;
        CurrencyAmt?: number;
        ReceiptAmt?: number;
    }

    export namespace Report1332ShopPaymentTypeRefTypeRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ShopId';
        export const localTextPrefix = 'ReportMasterData.Report1332ShopPaymentTypeRefType';
        export const deletePermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';
        export const insertPermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';
        export const readPermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';
        export const updatePermission = '1POSBASE:รายงาน:รายวันขาย:รายวันขาย:View';

        export declare const enum Fields {
            Id = "Id",
            ShopId = "ShopId",
            ShopName = "ShopName",
            DocDate = "DocDate",
            PaymentType = "PaymentType",
            PaymentName = "PaymentName",
            RefType = "RefType",
            RefName = "RefName",
            ExchangeRate = "ExchangeRate",
            ReceiptInAmt = "ReceiptInAmt",
            ReceiptOutAmt = "ReceiptOutAmt",
            CurrencyAmt = "CurrencyAmt",
            ReceiptAmt = "ReceiptAmt"
        }
    }
}
